import { schedulingActions } from './scheduling-slice';
import {
  getAllocations,
  getProfessionals,
  getEngagements,
  getProfessional,
  getEngagement
} from '@/services/schedulingService';

export const fetchAllocations = async dispatch => {
  try {
    dispatch(schedulingActions.setLoading(true));
    const response = await getAllocations();
    dispatch(schedulingActions.setAllocations(response));
    return response;
  } catch (error) {
    dispatch(schedulingActions.setError(error));
    return [];
  } finally {
    dispatch(schedulingActions.setLoading(false));
  }
};

export const fetchProfessionals = async dispatch => {
  try {
    dispatch(schedulingActions.setLoading(true));
    const response = await getProfessionals();
    dispatch(schedulingActions.setProfessionals(response));
    return response;
  } catch (error) {
    dispatch(schedulingActions.setError(error));
    return [];
  } finally {
    dispatch(schedulingActions.setLoading(false));
  }
};

export const fetchProfessional = async (dispatch, id) => {
  try {
    dispatch(schedulingActions.setLoading(true));
    const response = await getProfessional(id);
    dispatch(schedulingActions.setProfessionals(response));
    return response;
  } catch (error) {
    dispatch(schedulingActions.setError(error));
    return [];
  } finally {
    dispatch(schedulingActions.setLoading(false));
  }
};

export const fetchEngagements = async dispatch => {
  try {
    dispatch(schedulingActions.setLoading(true));
    const response = await getEngagements();
    dispatch(schedulingActions.setEngagements(response));
    return response;
  } catch (error) {
    dispatch(schedulingActions.setError(error));
    return [];
  } finally {
    dispatch(schedulingActions.setLoading(false));
  }
};

export const fetchEngagement = async (dispatch, id) => {
  try {
    dispatch(schedulingActions.setLoading(true));
    const response = await getEngagement(id);
    dispatch(schedulingActions.setEngagements(response));
    return response;
  } catch (error) {
    dispatch(schedulingActions.setError(error));
    return [];
  } finally {
    dispatch(schedulingActions.setLoading(false));
  }
};

export const cleanErrors = dispatch => {
  dispatch(schedulingActions.cleanErrors());
};

export const cleanstate = dispatch => {
  dispatch(schedulingActions.cleanState());
};
